import { RegistrationStatus } from '@fieldday/fielddayportal-model'
import { ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material'
import { useScheduledActivityContext } from '../../hooks/useScheduledActivityContext'
import { Registration } from '../../models/Registration'
import { UserHelper } from '../../models/UserHelper'
import UserAvatar from '../User/UserAvatar'

export default function ContactBox(props:{ registrations: Registration[] | null }) {
  const { scheduledActivity: sa, teamOwned } = useScheduledActivityContext()
  const { registrations } = props
  if (!registrations) return (<></>)

  const contacts = registrations.filter(r => r.status === RegistrationStatus.Point_Of_Contact)

  return contacts.length === 0 ?
    <>
      {!teamOwned && <Typography color="textSecondary">
        No nonprofit point of contact listed
      </Typography>}
    </>
  :
    <>
      {contacts.map(c => <EventContact r={c} key={c.id} orgName={sa.nonProfitOrg?.name ?? "Unknown nonprofit"} />)}
    </>
}

export function EventContact(props: { r: Registration, orgName: string }) {
  const { r, orgName } = props
  const rUser = new UserHelper(r.user)
  return (
    <ListItem sx={{ paddingLeft: 0, paddingRight: 0 }}>
      <ListItemAvatar>
        <UserAvatar userInfo={r.user} />
      </ListItemAvatar>
      <ListItemText
        sx={{ m: 0 }}
        primaryTypographyProps={{
          variant: "subhead3B",
        }}
        secondaryTypographyProps={{
          variant: "body1",
          color: "textPrimary",
        }}
        primary={orgName}
        secondary={rUser.displayName()}
      />
    </ListItem>
  )
}
